export default "__VITE_ASSET__8812454b__"